/**
 * Reads a signed `?tk=` recognition token from links we send, links this
 * browser to that visitor, then removes the token from the address bar so it
 * is never shared, bookmarked or sent to analytics.
 */
import { useEffect } from "react";
import { toast } from "sonner";

export function IdentityLinkHandler() {
  useEffect(() => {
    if (typeof window === "undefined") return;
    const url = new URL(window.location.href);
    const tk = url.searchParams.get("tk");
    if (!tk) return;
    url.searchParams.delete("tk");
    window.history.replaceState(window.history.state, "", url.pathname + url.search + url.hash);
    void (async () => {
      try {
        const { getAnonymousId } = await import("@/lib/identity/anonymousId");
        const anonymousId = getAnonymousId();
        if (!anonymousId) return;
        const { redeemLinkToken } = await import("@/lib/identity/link-token.functions");
        const r = await redeemLinkToken({ data: { token: tk, anonymousId } });
        if (r.ok && r.firstName) toast.success(`Welcome back, ${r.firstName}`);
      } catch {
        /* recognition is best-effort */
      }
    })();
  }, []);
  return null;
}
